import { enumMembers, type ApiSchema } from "./apiSchema";

/**
 * An action of the server's permission table (`docs/components/accounts.md`, `Action`), on the
 * installation, a project or an item. The server decides each for the user (`access/decisions`).
 */
export type PermittedAction = ApiSchema<"Action">;

export const PERMITTED_ACTIONS = enumMembers<PermittedAction>({
  create_project: true,
  manage_accounts: true,
  read_project: true,
  comment: true,
  propose_change: true,
  manage_members: true,
  manage_curators: true,
  manage_project_settings: true,
  review_change: true,
  read_repository: true,
  push_repository: true,
  make_release: true,
  manage_server_keys: true,
  use_server_keys: true,
  manage_installation: true,
  report_problem: true,
  delete_project: true,
  manage_deleted_projects: true,
});
